import { type MainResultSet } from "#/services/rest/gwt/exam-results/views/type-1/multi-user.types";
import NoWrongAnswers from "../NoWrongAnswers";
import Tithe from "../Tithe";
import styles from "./styles.module.scss";

type Props = {
  data: MainResultSet[];
  totalStudentNO: number;
};

const GeneralInfoTable = (props: Props) => {
  const { data, totalStudentNO } = props;

  return (
    <>
      <div className={styles["desktop"]}>
        <div className={styles["table"]}>
          <div className={styles["table__header"]}>
            <span>نام گروه درسی</span>
            <span>رتبه</span>
            <span>تراز</span>
            <span>درصد</span>
            <span>دهک</span>
            <span>میانگین درصد نفرات برتر</span>
            <span>رتبه و تراز بدون پاسخ اشتباه</span>
          </div>

          <div className={styles["table__content"]}>
            {data.map((moduleGroup, index) => (
              <div className={styles["table__content-row"]} key={index}>
                <div className={styles["table__content-row__moduleGroup"]}>
                  {moduleGroup.name}
                </div>
                <div>{moduleGroup.rank}</div>
                <div>{moduleGroup.level}</div>
                <div>{moduleGroup.mark + " % "}</div>
                <div>
                  <Tithe tithe={moduleGroup.tierNO} />
                </div>
                <div>{moduleGroup.topMarkAvg + " % "}</div>
                <div className={styles["table__content-row__text"]}>
                  <div>رتبه: {moduleGroup.rank}</div>
                  <div>تراز: {moduleGroup.level}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles["mobile"]}>
        {data.map((moduleGroup, index) => (
          <div className={styles["question"]} key={index}>
            <div className={styles["question__header"]}>
              <div>{moduleGroup.name}</div>
              <div>
                <Tithe tithe={moduleGroup.tierNO} />
              </div>
            </div>
            <div className={styles["question__divider"]} />
            <div className={styles["question__body"]}>
              <div className={styles["question__body-row"]}></div>
              <div className={styles["question__body-row"]}>
                <span>:رتبه</span>
                <span className={styles["question__body-row--rtl"]}>
                  {moduleGroup.rank} از {totalStudentNO} نفر
                </span>
              </div>
              <div className={styles["question__body-row"]}>
                <span>:تراز</span>
                <span>{moduleGroup.level}</span>
              </div>
              <div className={styles["question__body-row"]}>
                <span>:درصد</span>
                <span>{moduleGroup.mark + " % "}</span>
              </div>
              <div className={styles["question__body-row"]}>
                <span>:میانگین درصد نفرات برتر </span>
                <span>{moduleGroup.topMarkAvg + " % "}</span>
              </div>
              {moduleGroup.incorrectAnswers !== 0 && (
                <div className={styles["question__body-row"]}>
                  <NoWrongAnswers
                    levelWN={moduleGroup.levelWN ?? 0}
                    rankWN={moduleGroup.rankWN ?? 0}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default GeneralInfoTable;
